import { z, ZodType } from 'zod';
import { WidgetsName, WidgetType } from './common';
import { jFileLittle, jFileLittleSchema } from '../file';
import { zObject } from '../../util/zod';

export type WidgetArticleGalleryContent = {
    gap?: string;
    column?: string;
    files?: jFileLittle[];
};
export const widgetArticleGalleryContentSchema = zObject<WidgetArticleGalleryContent>({
    gap: z.string().optional(),
    column: z.string().optional(),
    files: jFileLittleSchema.array().optional(),
});

export type WidgetArticleGalleryType = {
    name: WidgetsName.ArticleGallery;
    uniqid: string;
    content: WidgetArticleGalleryContent;
};
export const widgetArticleGalleryTypeSchema = zObject<WidgetArticleGalleryType>({
    name: z.literal(WidgetsName.ArticleGallery),
    uniqid: z.string(),
    content: widgetArticleGalleryContentSchema,
}) satisfies ZodType<WidgetType<WidgetArticleGalleryContent>>;
